import { render, staticRenderFns } from "./container.component.vue?vue&type=template&id=167cbe69"
import script from "./container.component.vue?vue&type=script&lang=js"
export * from "./container.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports